<template>
  <v-layout row>
    <v-dialog
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      v-model="botScheduler"
      :disabled="disabled"
    >
      <v-btn v-if="showLabel" slot="activator" :disabled="disabled">
        <v-icon>mdi-run</v-icon>
        <span class="ml-2" v-show="showLabel">Automation Scheduler</span>
      </v-btn>
      <v-btn flat icon v-else slot="activator" :disabled="disabled">
        <v-icon color="secondary" medium>schedule</v-icon>
      </v-btn>
      <v-toolbar style="z-index: 999" dense fixed>
        <v-btn flat icon @click="botScheduler = false">
          <v-icon>close</v-icon>
        </v-btn>
        <div class="text-lg-left beez-bold ml-2">
          Automation Scheduler
        </div>
        <v-spacer />
        <v-btn
          flat
          :outline="$vuetify.dark"
          @click="showCron = !showCron"
          class="text-capitalize"
          v-if="cronScheduler"
        >
          <span>Toggle Cron Expression</span>
        </v-btn>
        <v-btn
          :disabled="cronScheduler && errorInCron"
          :outline="$vuetify.dark"
          color="secondary"
          class="text-capitalize mr-1"
          @click="validateJobInfo"
          :loading="scheduleCheckLoader"
        >
          <v-icon>schedule</v-icon>
          <span>Schedule</span>
        </v-btn>
        <v-dialog
          v-model="inputBox"
          max-width="800px"
          content-class="honey-popup"
        >
          <v-card>
            <v-toolbar dense card class="elevation-2">
              <div class="text-lg-left beez-bold ">
                Automation Inputs
              </div>
              <v-spacer />
              <v-btn flat icon @click="inputBox = false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-title v-if="item.proposals">
              <span class="subheading"
                >Please provide the inputs for the following fields</span
              >
            </v-card-title>
            <v-card-title v-else>
              <span class="subheading">Please confirm to schedule</span>
            </v-card-title>
            <v-card-text>
              <v-form>
                <v-flex xs12>
                  <proposal-renderer
                    :key="item.hexId + 'proposal-render'"
                    :proposals="item.proposals"
                    :readonly="false"
                    @submit="scheduleItem"
                    @cancel="inputBox = false"
                    v-if="item.proposals"
                  >
                  </proposal-renderer>
                </v-flex>
              </v-form>
            </v-card-text>
            <v-card-text>
              <v-form>
                <v-flex xs12>
                  <proposal-renderer
                    :proposals="item.proposals"
                    :readonly="false"
                    @submit="scheduleItem"
                    @cancel="inputBox = false"
                    v-if="!item.proposals"
                  >
                  </proposal-renderer>
                </v-flex>
              </v-form>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <v-card
        style="padding-top: 50px!important; padding-bottom: 10px!important;"
      >
        <v-flex class="pa-2 ma-2">
          <v-layout align-start justify-center row>
            <v-flex xs12>
              <v-card>
                <v-toolbar dense>
                  <div class="text-lg-left beez-bold">
                    Job details
                  </div>
                </v-toolbar>
                <v-flex class="pa-2 ma-2">
                  <v-layout align-center justify-center class="row wrap">
                    <v-card v-if="item">
                      <v-flex class="pa-2 ma-2">
                        <v-layout row wrap>
                          <v-flex xs12>
                            <div class="text-lg-left beez-bold ">
                              Selected item
                            </div>
                            <v-layout row wrap>
                              <v-flex xs12 md6 lg4>
                                <div class="text-xs-left">
                                  <br />
                                  <div>Type</div>
                                  <div class="subheading">{{ type }}</div>
                                  <br />
                                </div>
                              </v-flex>
                              <v-flex xs12 md6 lg4>
                                <div class="text-xs-left">
                                  <br />
                                  <div>Name</div>
                                  <div class="subheading">{{ item.name }}</div>
                                  <br />
                                </div>
                              </v-flex>
                              <v-flex xs12 md6 lg4>
                                <div class="text-xs-left">
                                  <br />
                                  <div>Description</div>
                                  <div class="subheading">
                                    {{ item.description }}
                                  </div>
                                  <br />
                                </div>
                              </v-flex>
                              <v-flex xs12 md6 lg4 v-if="type === 'Bot'">
                                <div class="text-xs-left">
                                  <br />
                                  <div>Agent Description</div>
                                  <div class="subheading">
                                    {{ item.description }}
                                  </div>
                                  <br />
                                </div>
                              </v-flex>
                              <v-flex
                                xs12
                                md6
                                lg4
                                v-else-if="type === 'Workflow'"
                              >
                                <div class="text-xs-left">
                                  <br />
                                  <div>Workflow Process Id</div>
                                  <div class="subheading">
                                    {{ item.processId }}
                                  </div>
                                  <br />
                                </div>
                              </v-flex>
                              <v-flex
                                xs12
                                md6
                                lg4
                                v-else-if="item.itemType === 'Hive'"
                              >
                                <div class="text-xs-left">
                                  <br />
                                  <div>Agent Type</div>
                                  <div class="subheading">{{ type }}</div>
                                  <br />
                                </div>
                              </v-flex>
                              <v-flex xs12 md6 lg4>
                                <div class="text-xs-left">
                                  <br />
                                  <div>Created By</div>
                                  <div class="subheading">
                                    {{ item.createdByUser }}
                                  </div>
                                  <br />
                                </div>
                              </v-flex>
                              <v-flex xs12 md6 lg4>
                                <div class="text-xs-left">
                                  <br />
                                  <div>Created At</div>
                                  <div class="subheading">
                                    {{ item.createdAtLocal }}
                                  </div>
                                  <br />
                                </div>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex xs12>
                            <v-divider style="padding: 10px;" />
                            <div class="text-lg-left beez-bold ">
                              Job Details
                            </div>
                            <v-form ref="jobForm" v-model="validForm">
                              <v-layout row wrap>
                                <v-flex xs12 sm6 md4 style="padding: 10px">
                                  <v-text-field
                                    autofocus
                                    color="secondary"
                                    label="Job Name"
                                    outline
                                    :rules="[rules.required]"
                                    v-model="jobName"
                                    required
                                    placeholder="Required"
                                    clearable
                                  />
                                </v-flex>
                                <v-flex xs12 sm6 md4 style="padding: 10px">
                                  <v-text-field
                                    color="secondary"
                                    label="Group Name"
                                    outline
                                    :rules="[rules.required]"
                                    required
                                    placeholder="Required"
                                    v-model="groupName"
                                    clearable
                                  />
                                </v-flex>
                                <v-flex xs12 sm6 md4 style="padding: 10px">
                                  <v-text-field
                                    label="Description"
                                    outline
                                    color="secondary"
                                    v-model="jobDescription"
                                    clearable
                                  />
                                </v-flex>
                                <v-flex xs12>
                                  <v-divider style="padding: 10px;" />
                                  <div class="text-lg-left beez-bold ">
                                    Trigger Details
                                  </div>
                                </v-flex>
                                <v-flex xs12 sm6 md4 style="padding: 10px;">
                                  <v-switch
                                    label="Recurring Job (CRON Scheduler)"
                                    v-model="cronScheduler"
                                    color="secondary"
                                  />
                                </v-flex>
                              </v-layout>
                            </v-form>
                          </v-flex>
                        </v-layout>

                        <div v-if="!cronScheduler">
                          <div class="body-2 text-lg-left">
                            One time job schedule
                          </div>
                          <v-layout
                            align-center
                            justify-space-between
                            row
                            fill-height
                          >
                            <v-flex xs12 sm6>
                              <v-date-picker
                                v-model="simpleJobDate"
                                color="secondary"
                              />
                            </v-flex>
                            <v-flex xs12 sm6>
                              <v-time-picker
                                v-model="simpleJobTime"
                                color="secondary"
                              />
                            </v-flex>
                          </v-layout>
                        </div>
                        <div v-else>
                          <div
                            class="body-2 text-lg-left "
                            v-html="CRONHelp"
                          ></div>
                          <v-layout align-start justify-center row>
                            <v-flex xs12>
                              <v-card>
                                <v-toolbar dense card class="elevation-2">
                                  <div class="text-lg-left beez-bold">
                                    Choose a template to schedule
                                  </div>
                                  <v-spacer></v-spacer>
                                  <v-btn
                                    flat
                                    icon
                                    @click="showTemplates = !showTemplates"
                                  >
                                    <v-icon
                                      >{{
                                        showTemplates
                                          ? 'keyboard_arrow_up'
                                          : 'keyboard_arrow_down'
                                      }}
                                    </v-icon>
                                  </v-btn>
                                </v-toolbar>
                                <v-layout v-if="showTemplates">
                                  <v-flex
                                    style="height: 50%;"
                                    class="scroll-y pa-2 ma-2"
                                  >
                                    <v-layout class="row wrap">
                                      <v-flex
                                        d-flex
                                        xs12
                                        sm6
                                        md4
                                        lg4
                                        v-for="(templateItem,
                                        temp_i) in templates"
                                        :key="'template-' + temp_i"
                                        style="padding: 10px"
                                      >
                                        <v-card
                                          hover
                                          style="border-radius: 5px"
                                          @click="selectTemplate(templateItem)"
                                        >
                                          <v-card-text>
                                            <v-layout row wrap>
                                              <v-flex xs12>
                                                <v-flex xs12>
                                                  <div
                                                    class="body-1 text-lg-left "
                                                  >
                                                    {{ templateItem.label }}
                                                  </div>
                                                </v-flex>
                                                <v-flex xs12>
                                                  <div
                                                    class="caption text-lg-left "
                                                  >
                                                    {{
                                                      templateItem.description
                                                    }}
                                                  </div>
                                                </v-flex>
                                              </v-flex>
                                            </v-layout>
                                          </v-card-text>
                                        </v-card>
                                      </v-flex>
                                    </v-layout>
                                  </v-flex>
                                </v-layout>
                              </v-card>
                            </v-flex>
                          </v-layout>
                          <v-layout
                            align-start
                            justify-center
                            row
                            style="padding-top: 10px; padding-bottom: 40px"
                          >
                            <v-flex xs12>
                              <v-card>
                                <v-toolbar dense>
                                  <div class="text-lg-left beez-bold">
                                    Inclusions
                                  </div>
                                  <v-spacer></v-spacer>
                                  <v-tooltip bottom>
                                    <v-btn
                                      flat
                                      slot="activator"
                                      icon
                                      @click="addInclusion()"
                                    >
                                      <v-icon>add</v-icon>
                                    </v-btn>
                                    <span>Add Inclusions</span>
                                  </v-tooltip>
                                  <v-tooltip bottom>
                                    <v-btn
                                      flat
                                      slot="activator"
                                      icon
                                      @click="setCronExpressionFromInclusions()"
                                    >
                                      <v-icon>check_circle</v-icon>
                                    </v-btn>
                                    <span>Commit All</span>
                                  </v-tooltip>
                                  <v-tooltip bottom>
                                    <v-btn
                                      flat
                                      slot="activator"
                                      icon
                                      @click="
                                        showInclusionHelp = !showInclusionHelp
                                      "
                                    >
                                      <v-icon>help</v-icon>
                                    </v-btn>
                                    <span>Help</span>
                                  </v-tooltip>
                                  <v-btn
                                    flat
                                    icon
                                    @click="showInclusions = !showInclusions"
                                  >
                                    <v-icon
                                      >{{
                                        showInclusions
                                          ? 'keyboard_arrow_up'
                                          : 'keyboard_arrow_down'
                                      }}
                                    </v-icon>
                                  </v-btn>
                                </v-toolbar>
                                <v-layout v-if="showInclusions">
                                  <v-flex
                                    style="height: 80%;"
                                    class="scroll-y pa-2 ma-2"
                                  >
                                    <v-card v-if="showInclusionHelp">
                                      <v-card-text>
                                        <v-layout class="row wrap">
                                          <v-flex xs1>
                                            <v-icon color="secondary"
                                              >help
                                            </v-icon>
                                          </v-flex>
                                          <v-flex xs11>
                                            <div class="caption text-lg-left ">
                                              Inclusions helps in creating
                                              complex cron expression** using
                                              intuitive user interface.
                                              <blockquote>
                                                Select
                                                <v-btn
                                                  flat
                                                  icon
                                                  color="secondary"
                                                  @click="addInclusion()"
                                                >
                                                  <v-icon>add</v-icon>
                                                </v-btn>
                                                from the above toolbar to add
                                                new inclusion.
                                              </blockquote>
                                              <blockquote>
                                                Note: In case of conflicting
                                                inclusions, The latest inclusion
                                                takes precedence.
                                              </blockquote>
                                              <br />
                                              <blockquote>
                                                **A cron expression is a string
                                                comprised of 7 fields separated
                                                by white space. Fields can
                                                contain any of the allowed
                                                values, along with various
                                                combinations of the allowed
                                                special characters for that
                                                field. The fields are as
                                                follows:
                                              </blockquote>
                                              <table
                                                cellpadding="3"
                                                cellspacing="1"
                                                border="1"
                                              >
                                                <tbody>
                                                  <tr>
                                                    <th>Field Name</th>
                                                    <th>Mandatory</th>
                                                    <th>Allowed Values</th>
                                                    <th>
                                                      Allowed Special Characters
                                                    </th>
                                                  </tr>
                                                  <tr>
                                                    <td>Seconds</td>
                                                    <td>YES</td>

                                                    <td>0-59</td>
                                                    <td>, - * /</td>
                                                  </tr>
                                                  <tr>
                                                    <td>Minutes</td>
                                                    <td>YES</td>
                                                    <td>0-59</td>

                                                    <td>, - * /</td>
                                                  </tr>
                                                  <tr>
                                                    <td>Hours</td>
                                                    <td>YES</td>
                                                    <td>0-23</td>
                                                    <td>, - * /</td>
                                                  </tr>
                                                  <tr>
                                                    <td>Day of month</td>
                                                    <td>YES</td>
                                                    <td>1-31</td>
                                                    <td>
                                                      , - * ? / L W<br
                                                        clear="all"
                                                      />
                                                    </td>
                                                  </tr>
                                                  <tr>
                                                    <td>Month</td>
                                                    <td>YES</td>
                                                    <td>1-12 or JAN-DEC</td>
                                                    <td>, - * /</td>
                                                  </tr>
                                                  <tr>
                                                    <td>Day of week</td>

                                                    <td>YES</td>
                                                    <td>1-7 or SUN-SAT</td>
                                                    <td>, - * ? / L #</td>
                                                  </tr>
                                                  <tr>
                                                    <td>Year</td>
                                                    <td>NO</td>

                                                    <td>empty, 1970-2099</td>
                                                    <td>, - * /</td>
                                                  </tr>
                                                </tbody>
                                              </table>
                                              <br />
                                              <p>
                                                So cron expressions can be as
                                                simple as this:
                                                <kbd>* * * * ? *</kbd>
                                              </p>

                                              <p>
                                                or more complex, like this:
                                                <kbd
                                                  >0/5 14,18,3-39,52 * ?
                                                  JAN,MAR,SEP MON-FRI
                                                  2002-2010</kbd
                                                >
                                              </p>
                                              <blockquote>
                                                The cron expression can also be
                                                directly changed, select
                                                <v-btn
                                                  flat
                                                  @click="showCron = !showCron"
                                                  color="secondary"
                                                  class="text-capitalize"
                                                >
                                                  <span>
                                                    Toogle Cron Expression
                                                  </span>
                                                </v-btn>
                                                in the main toolbar to view and
                                                edit the cron expression.
                                              </blockquote>
                                            </div>
                                          </v-flex>
                                        </v-layout>
                                      </v-card-text>
                                      <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <!-- <v-btn
                                            flat
                                            icon
                                            @click="
                                              showInclusionHelp = !showInclusionHelp
                                            "
                                          >
                                            <v-icon>close</v-icon>
                                          </v-btn> -->
                                      </v-card-actions>
                                    </v-card>
                                    <br v-if="showInclusionHelp" />
                                    <v-layout class="row wrap">
                                      <v-flex
                                        d-flex
                                        xs12
                                        md6
                                        lg6
                                        v-for="(inclusionItem,
                                        incl_i) in inclusionList"
                                        :key="'inclusion-' + incl_i"
                                        style="padding: 10px"
                                      >
                                        <template style="padding: 10px">
                                          <job-inclusion-item
                                            :key="'inclusion-item' + incl_i"
                                            @delete="
                                              deleteInclusion(inclusionItem)
                                            "
                                            :item.sync="inclusionList[incl_i]"
                                            @compute="
                                              setCronExpressionFromInclusions()
                                            "
                                          />
                                          <br />
                                        </template>
                                      </v-flex>
                                    </v-layout>
                                  </v-flex>
                                </v-layout>
                              </v-card>
                            </v-flex>
                          </v-layout>
                        </div>
                      </v-flex>
                    </v-card>
                  </v-layout>
                </v-flex>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-card>
      <div v-if="cronScheduler">
        <div
          :class="$vuetify.dark ? 'fixed-element-dark' : 'fixed-element-light'"
        >
          <v-layout align-start justify-center row fill-height>
            <v-flex xs12 sm1>
              <v-text-field
                label="Seconds"
                outline
                v-model="cron.pattern.seconds"
                v-if="showCron"
                style="padding-right: 4px"
              />
            </v-flex>
            <v-flex xs12 sm1>
              <v-text-field
                label="Minutes"
                outline
                v-model="cron.pattern.minutes"
                v-if="showCron"
                style="padding-right: 4px"
              />
            </v-flex>
            <v-flex xs12 sm1>
              <v-text-field
                label="Hours"
                outline
                v-model="cron.pattern.hours"
                v-if="showCron"
                style="padding-right: 4px"
              />
            </v-flex>
            <v-flex xs12 sm2>
              <v-text-field
                label="Day of month"
                outline
                v-model="cron.pattern.dayOfMonth"
                v-if="showCron"
                style="padding-right: 4px"
              />
            </v-flex>
            <v-flex xs12 sm1>
              <v-text-field
                label="Month"
                outline
                v-model="cron.pattern.month"
                v-if="showCron"
                style="padding-right: 4px"
              />
            </v-flex>
            <v-flex xs12 sm2>
              <v-text-field
                label="Day of week"
                outline
                v-model="cron.pattern.dayOfWeek"
                v-if="showCron"
                style="padding-right: 4px"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm1>
              <v-text-field
                label="Year"
                outline
                v-model="cron.pattern.year"
                v-if="showCron"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout align-start justify-center row fill-height>
            <div
              v-if="!errorInCron"
              class="headline text-capitalize beez-bold font-weight-light font-italic"
              style="padding-bottom: 40px"
            >
              <kbd>{{ cronMessage }}</kbd>
            </div>
            <div
              v-else-if="errorInCron"
              class="headline text-capitalize beez-bold red--text font-weight-light font-italic"
              style="padding-bottom: 40px"
            >
              <code>{{ cronMessage }}</code>
            </div>
          </v-layout>
        </div>
        <div v-if="showCron" style="padding: 40px"></div>
      </div>
    </v-dialog>
  </v-layout>
</template>
<script>
import cronstrue from 'cronstrue'
import moment from 'moment'
import utils from '@/utils'
import ProposalRenderer from '../common/ProposalRenderer'
import JobInclusionItem from '@/components/bot-scheduler/JobInclusionItem'
import axios from 'axios'

export default {
  name: 'bot-scheduler',
  components: { JobInclusionItem, ProposalRenderer },
  props: {
    item: Object,
    type: String,
    showLabel: Boolean,
    disabled: Boolean
  },
  computed: {
    cronMessage: function() {
      let cronMessage = this.getCronPattern(this.cron.pattern)
      try {
        const message = cronstrue.toString(cronMessage, {
          dayOfWeekStartIndexZero: false
        })
        this.errorInCron = false
        return 'Schedule runs: ' + message
      } catch (e) {
        this.errorInCron = true
        return e
      }
    }
  },
  data: () => ({
    errorInCron: false,
    botScheduler: false,
    CRONHelp:
      '<p>All CRON schedules will run in Time zone <b>Coordinated Universal Time (or UTC)<b></p>',
    cronScheduler: false,
    showTip: false,
    showCron: false,
    inputBox: false,
    scheduleCheckLoader: false,
    values: [],
    groupName: null,
    jobDescription: null,
    jobName: null,
    validForm: false,
    rules: {
      required: value => !!value || 'Required.'
    },
    simpleJobDate: null,
    simpleJobTime: null,
    showInclusionHelp: false,
    showInclusions: true,
    showTemplates: true,
    cron: {
      cronExpression: null,
      valid: true,
      pattern: {
        seconds: '*',
        minutes: '*',
        hours: '*',
        dayOfMonth: '*',
        month: '*',
        dayOfWeek: '?',
        year: '*'
      }
    },
    inclusionTypes: [
      {
        type: 'Second',
        values: Array.apply(null, { length: 60 }).map(Number.call, Number),
        options: [{ name: 'Every' }, { name: 'Range' }, { name: 'Increment' }]
      },
      {
        type: 'Minute',
        values: Array.apply(null, { length: 60 }).map(Number.call, Number),
        options: [{ name: 'Every' }, { name: 'Range' }, { name: 'Increment' }]
      },
      {
        type: 'Hour',
        values: Array.apply(null, { length: 24 }).map(Number.call, Number),
        options: [{ name: 'Every' }, { name: 'Range' }, { name: 'Increment' }]
      },
      {
        type: 'Day of month',
        values: Array(31)
          .fill()
          .map((_, idx) => 1 + idx),
        options: [
          { name: 'Every' },
          { name: 'Range' },
          { name: 'Increment' },
          { name: 'Last' },
          { name: 'Weekday' }
        ]
      },
      {
        type: 'Month',
        values: [
          'JAN',
          'FEB',
          'MAR',
          'APR',
          'MAY',
          'JUN',
          'JUL',
          'AUG',
          'SEP',
          'OCT',
          'NOV',
          'DEC'
        ],
        options: [{ name: 'Every' }, { name: 'Range' }, { name: 'Increment' }]
      },
      {
        type: 'Day of week',
        values: ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'],
        options: [
          { name: 'Every' },
          { name: 'Range' },
          { name: 'Increment' },
          { name: 'Last' },
          { name: 'Weekday' },
          { name: 'nth Day' }
        ]
      },
      {
        type: 'Year',
        values: Array(130)
          .fill()
          .map((_, idx) => 1970 + idx),
        options: [{ name: 'Every' }, { name: 'Range' }, { name: 'Increment' }]
      }
    ],
    templates: [
      {
        label: 'Hourly',
        description: 'Runs once every hour',
        inclusions: [
          {
            count: 1,
            type: 'Second',
            options: 'Every',
            value1: [0],
            value2: null,
            specialValue: 'default'
          },
          {
            count: 2,
            type: 'Minute',
            options: 'Every',
            value1: [0],
            value2: null,
            specialValue: 'default'
          },
          {
            count: 3,
            type: 'Hour',
            options: 'Every',
            value1: null,
            value2: null,
            specialValue: '*'
          },
          {
            count: 4,
            type: 'Day of month',
            options: 'Every',
            value1: null,
            value2: null,
            specialValue: '*'
          },
          {
            count: 5,
            type: 'Month',
            options: 'Every',
            value1: null,
            value2: null,
            specialValue: '*'
          },
          {
            count: 6,
            type: 'Day of week',
            options: 'Every',
            value1: null,
            value2: null,
            specialValue: '?'
          },
          {
            count: 7,
            type: 'Year',
            options: 'Every',
            value1: null,
            value2: null,
            specialValue: '*'
          }
        ]
      },
      {
        label: 'Daily',
        description: 'Runs once every day at 12:00 AM',
        inclusions: [
          {
            count: 1,
            type: 'Second',
            options: 'Every',
            value1: [0],
            value2: null,
            specialValue: 'default'
          },
          {
            count: 2,
            type: 'Minute',
            options: 'Every',
            value1: [0],
            value2: null,
            specialValue: 'default'
          },
          {
            count: 3,
            type: 'Hour',
            options: 'Every',
            value1: [0],
            value2: null,
            specialValue: 'default'
          },
          {
            count: 4,
            type: 'Day of month',
            options: 'Every',
            value1: null,
            value2: null,
            specialValue: '*'
          },
          {
            count: 5,
            type: 'Month',
            options: 'Every',
            value1: null,
            value2: null,
            specialValue: '*'
          },
          {
            count: 6,
            type: 'Day of week',
            options: 'Every',
            value1: null,
            value2: null,
            specialValue: '?'
          },
          {
            count: 7,
            type: 'Year',
            options: 'Every',
            value1: null,
            value2: null,
            specialValue: '*'
          }
        ]
      },
      {
        label: 'On every Weekday',
        description:
          'Runs once on every weekday (Monday to Friday) at 12:00 AM',
        inclusions: [
          {
            count: 1,
            type: 'Second',
            options: 'Every',
            value1: [0],
            value2: null,
            specialValue: 'default'
          },
          {
            count: 2,
            type: 'Minute',
            options: 'Every',
            value1: [0],
            value2: null,
            specialValue: 'default'
          },
          {
            count: 3,
            type: 'Hour',
            options: 'Every',
            value1: [0],
            value2: null,
            specialValue: 'default'
          },
          {
            count: 4,
            type: 'Day of month',
            options: 'Every',
            value1: null,
            value2: null,
            specialValue: '?'
          },
          {
            count: 5,
            type: 'Month',
            options: 'Every',
            value1: null,
            value2: null,
            specialValue: '*'
          },
          {
            count: 6,
            type: 'Day of week',
            options: 'Range',
            value1: ['MON'],
            value2: ['FRI'],
            specialValue: 'default'
          },
          {
            count: 7,
            type: 'Year',
            options: 'Every',
            value1: null,
            value2: null,
            specialValue: '*'
          }
        ]
      },
      {
        label: 'On every Weekend',
        description:
          'Runs once on every weekend (Saturday and Sunday) at 12:00 AM',
        inclusions: [
          {
            count: 1,
            type: 'Second',
            options: 'Every',
            value1: [0],
            value2: null,
            specialValue: 'default'
          },
          {
            count: 2,
            type: 'Minute',
            options: 'Every',
            value1: [0],
            value2: null,
            specialValue: 'default'
          },
          {
            count: 3,
            type: 'Hour',
            options: 'Every',
            value1: [0],
            value2: null,
            specialValue: 'default'
          },
          {
            count: 4,
            type: 'Day of month',
            options: 'Every',
            value1: null,
            value2: null,
            specialValue: '?'
          },
          {
            count: 5,
            type: 'Month',
            options: 'Every',
            value1: null,
            value2: null,
            specialValue: '*'
          },
          {
            count: 6,
            type: 'Day of week',
            options: 'Every',
            value1: ['SAT', 'SUN'],
            value2: null,
            specialValue: 'default'
          },
          {
            count: 7,
            type: 'Year',
            options: 'Every',
            value1: null,
            value2: null,
            specialValue: '*'
          }
        ]
      },
      {
        label: 'On every Monday',
        description: 'Runs once on every Monday at 12:00 AM',
        inclusions: [
          {
            count: 1,
            type: 'Second',
            options: 'Every',
            value1: [0],
            value2: null,
            specialValue: 'default'
          },
          {
            count: 2,
            type: 'Minute',
            options: 'Every',
            value1: [0],
            value2: null,
            specialValue: 'default'
          },
          {
            count: 3,
            type: 'Hour',
            options: 'Every',
            value1: [0],
            value2: null,
            specialValue: 'default'
          },
          {
            count: 4,
            type: 'Day of month',
            options: 'Every',
            value1: null,
            value2: null,
            specialValue: '?'
          },
          {
            count: 5,
            type: 'Month',
            options: 'Every',
            value1: null,
            value2: null,
            specialValue: '*'
          },
          {
            count: 6,
            type: 'Day of week',
            options: 'Every',
            value1: ['MON'],
            value2: null,
            specialValue: 'default'
          },
          {
            count: 7,
            type: 'Year',
            options: 'Every',
            value1: null,
            value2: null,
            specialValue: '*'
          }
        ]
      },
      {
        label: '1st day of every year',
        description: 'Runs once on every January 1st at 12:00 AM',
        inclusions: [
          {
            count: 1,
            type: 'Second',
            options: 'Every',
            value1: [0],
            value2: null,
            specialValue: 'default'
          },
          {
            count: 2,
            type: 'Minute',
            options: 'Every',
            value1: [0],
            value2: null,
            specialValue: 'default'
          },
          {
            count: 3,
            type: 'Hour',
            options: 'Every',
            value1: [0],
            value2: null,
            specialValue: 'default'
          },
          {
            count: 4,
            type: 'Day of month',
            options: 'Every',
            value1: [1],
            value2: null,
            specialValue: 'default'
          },
          {
            count: 5,
            type: 'Month',
            options: 'Every',
            value1: ['JAN'],
            value2: null,
            specialValue: 'default'
          },
          {
            count: 6,
            type: 'Day of week',
            options: 'Every',
            value1: null,
            value2: null,
            specialValue: '?'
          },
          {
            count: 7,
            type: 'Year',
            options: 'Every',
            value1: null,
            value2: null,
            specialValue: '*'
          }
        ]
      },
      {
        label: 'Every Second',
        description: 'Runs once every second',
        inclusions: [
          {
            count: 1,
            type: 'Second',
            options: 'Every',
            value1: null,
            value2: null,
            specialValue: '*'
          },
          {
            count: 2,
            type: 'Minute',
            options: 'Every',
            value1: null,
            value2: null,
            specialValue: '*'
          },
          {
            count: 3,
            type: 'Hour',
            options: 'Every',
            value1: null,
            value2: null,
            specialValue: '*'
          },
          {
            count: 4,
            type: 'Day of month',
            options: 'Every',
            value1: null,
            value2: null,
            specialValue: '*'
          },
          {
            count: 5,
            type: 'Month',
            options: 'Every',
            value1: null,
            value2: null,
            specialValue: '*'
          },
          {
            count: 6,
            type: 'Day of week',
            options: 'Every',
            value1: null,
            value2: null,
            specialValue: '?'
          },
          {
            count: 7,
            type: 'Year',
            options: 'Every',
            value1: null,
            value2: null,
            specialValue: '*'
          }
        ]
      },
      {
        label: 'Every Minute',
        description: 'Runs once every minute',
        inclusions: [
          {
            count: 1,
            type: 'Second',
            options: 'Every',
            value1: [0],
            value2: null,
            specialValue: 'default'
          },
          {
            count: 2,
            type: 'Minute',
            options: 'Every',
            value1: null,
            value2: null,
            specialValue: '*'
          },
          {
            count: 3,
            type: 'Hour',
            options: 'Every',
            value1: null,
            value2: null,
            specialValue: '*'
          },
          {
            count: 4,
            type: 'Day of month',
            options: 'Every',
            value1: null,
            value2: null,
            specialValue: '*'
          },
          {
            count: 5,
            type: 'Month',
            options: 'Every',
            value1: null,
            value2: null,
            specialValue: '*'
          },
          {
            count: 6,
            type: 'Day of week',
            options: 'Every',
            value1: null,
            value2: null,
            specialValue: '?'
          },
          {
            count: 7,
            type: 'Year',
            options: 'Every',
            value1: null,
            value2: null,
            specialValue: '*'
          }
        ]
      }
    ],
    inclusionList: []
  }),
  mounted() {
    this.cron.pattern.seconds = '*'
    this.cron.pattern.minutes = '*'
    this.cron.pattern.hours = '*'
    this.cron.pattern.dayOfMonth = '*'
    this.cron.pattern.month = '*'
    this.cron.pattern.dayOfWeek = '?'
    this.cron.pattern.year = '*'
    this.simpleJobDate = moment().format('YYYY-MM-DD')
    this.simpleJobTime = moment().format('HH:mm')
  },
  methods: {
    async validateJobInfo() {
      if (!this.jobName || !this.groupName) {
        this.$refs.jobForm.validate()
        return
      } else if (this.$refs.jobForm.validate()) {
        this.scheduleCheckLoader = true

        axios
          .get(
            '/api/v1/jobSchedules/checkName?jobName=' +
              this.jobName +
              '&groupName=' +
              this.groupName
          )
          .then(response => {
            this.scheduleCheckLoader = false
            if (response.status === 200) {
              let check = response.data
              if (check && !check.result) {
                if (this.cronScheduler) {
                  let cronExpression = this.getCronPattern(this.cron.pattern)
                  axios
                    .get(
                      '/api/v1/jobSchedules/validateCRON?cronExpression=' +
                        cronExpression
                    )
                    .then(response => {
                      if (response.status === 200) {
                        let check = response.data
                        if (check && check.valid) {
                          this.inputBox = !this.inputBox
                        } else {
                          this.$store.dispatch('directNotification', {
                            timestamp: moment().format(
                              'DD MMM YYYY hh:mm:ss a'
                            ),
                            description:
                              'Invalid Cron Expression: ' +
                              check.message +
                              ', Please check!',
                            message: 'Invalid Cron Expression',
                            type: 'error'
                          })
                        }
                      } else {
                        this.$store.dispatch('directNotification', {
                          timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
                          description:
                            'Invalid Cron Expression: ' +
                            check.message +
                            ', Please check!',
                          message: 'Invalid Cron Expression',
                          type: 'error'
                        })
                      }
                    })
                    .catch(error => {
                      this.$store.dispatch('directNotification', {
                        timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
                        description:
                          'Invalid Cron Expression: ' +
                          error.message +
                          ', Please check!',
                        message: 'Invalid Cron Expression',
                        type: 'error'
                      })
                    })
                } else {
                  let jobScheduleTime = new Date(
                    this.simpleJobDate + ' ' + this.simpleJobTime
                  )
                  if (moment().isAfter(jobScheduleTime)) {
                    this.$store.dispatch('directNotification', {
                      timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
                      description:
                        'Job schedule Date time is in past ' +
                        jobScheduleTime +
                        ', Please check!',
                      message: 'Job schedule is in past',
                      type: 'error'
                    })
                  } else {
                    this.inputBox = !this.inputBox
                  }
                }
              } else {
                this.$store.dispatch('directNotification', {
                  timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
                  message:
                    'Job with the same name already exists in the group, Please choose a different name',
                  type: 'error'
                })
              }
            } else {
              this.$store.dispatch('directNotification', {
                timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
                description: 'Job Name and Group Name are invalid',
                message: 'Invalid Job Name and Group Name',
                type: 'error'
              })
            }
          })
      }
      this.scheduleCheckLoader = false
    },
    getInput(model) {
      this.inputBox = false

      let itemInputs = {}
      var inputArray = Object.keys(model)
      for (var i = 0; i < inputArray.length; i++) {
        itemInputs[inputArray[i]] = {
          value: model[inputArray[i]],
          type: 'STRING',
          objectTypeName: 'java.lang.String',
          flowVariable: false
        }
      }
      return itemInputs
    },
    async scheduleItem(model) {
      let data = {}

      data.jobName = this.jobName
      data.groupName = this.groupName
      data.description = this.jobDescription

      if (this.type === 'Workflow') {
        data.workflow = true
        data.workflowExecutionModel = {}
        data.workflowExecutionModel.workflowId = this.item.hexId
        data.workflowExecutionModel.workflowVariables = this.getInput(model)
      } else {
        data.workflow = false
        data.botExchangeModel = {}
        data.botExchangeModel.botId = this.item.hexId
        data.botExchangeModel.botInputs = this.getInput(model)
      }
      if (!this.cronScheduler) {
        let jobScheduleTime = new Date(
          this.simpleJobDate + ' ' + this.simpleJobTime
        )
        if (moment().isAfter(jobScheduleTime)) {
          this.$store.dispatch('directNotification', {
            timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
            description:
              'Job schedule Date time is in past ' +
              jobScheduleTime +
              ', Please check!',
            message: 'Job schedule is in past',
            type: 'error'
          })
          return
        }
        data.jobScheduleTime = moment.utc(jobScheduleTime)
      } else if (this.cronScheduler) {
        data.jobScheduleTime = moment.utc().format()
        data.cronExpression = this.getCronPattern(this.cron.pattern)
      }

      try {
        let response = await this.$store.dispatch('scheduleJob', data)
        let r = utils.processResp(response.data)
        this.$store.dispatch('directNotification', {
          type: 'success',
          message: 'Job has been scheduled Successfully',
          description: 'Job ' + r.hexId + ' has been scheduled successfully ',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
        this.botScheduler = false
      } catch (e) {
        this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Job Schedule has Failed',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
        this.botScheduler = false
      }
    },
    inclusionTypeChanged(item) {
      if (item.selectedType) {
        let obj = this.inclusionTypes.find(x => x.type === item.selectedType)
        item.options = obj.options
        item.values = obj.values
      }
    },
    initInclusion(count) {
      return {
        step: count,
        inclusionTypes: [
          {
            type: 'Second'
          },
          {
            type: 'Minute'
          },
          {
            type: 'Hour'
          },
          {
            type: 'Day of month'
          },
          {
            type: 'Month'
          },
          {
            type: 'Day of week'
          },
          {
            type: 'Year'
          }
        ],
        selectedType: null,
        options: [],
        values: [],
        value1: [],
        value2: [],
        selectedOption: null,
        specialValue: 'default',
        selectIcon: 'check_box_outline_blank'
      }
    },
    initInclusionItem(count, type, option, value1, value2, specialValue) {
      let inclusion = this.initInclusion(count)
      inclusion.selectedType = type
      this.inclusionTypeChanged(inclusion)
      inclusion.selectedOption = option
      inclusion.value1 = value1
      inclusion.value2 = value2
      inclusion.specialValue = specialValue
      return inclusion
    },
    updateExpression() {
      this.cron.cronExpression = this.getCronPattern(this.cron.pattern)
    },
    getCronPattern(pattern) {
      return (
        pattern.seconds +
        ' ' +
        pattern.minutes +
        ' ' +
        pattern.hours +
        ' ' +
        pattern.dayOfMonth +
        ' ' +
        pattern.month +
        ' ' +
        pattern.dayOfWeek +
        ' ' +
        pattern.year
      )
    },
    selectTemplate(item) {
      let inclusionList = []
      let _self = this
      item.inclusions.forEach(function(item) {
        inclusionList.push(
          _self.initInclusionItem(
            item.count,
            item.type,
            item.options,
            item.value1,
            item.value2,
            item.specialValue
          )
        )
      })
      this.inclusionList = inclusionList
      this.setCronExpressionFromInclusions()
    },
    deleteInclusion(item) {
      if (item) {
        let index = this.inclusionList.indexOf(item)
        this.inclusionList.splice(index, 1)
      }
      this.setCronExpressionFromInclusions()
    },
    setCronExpressionFromInclusions() {
      let localPattern = {
        seconds: '*',
        minutes: '*',
        hours: '*',
        dayOfMonth: '*',
        month: '*',
        dayOfWeek: '*',
        year: '*'
      }
      this.inclusionList.forEach(function(item) {
        if (!item.selectedOption) {
          return
        }
        let currentPattern = ''

        switch (item.selectedOption) {
          case 'Every':
            if (item.specialValue !== 'default') {
              currentPattern = item.specialValue
            } else {
              if (!item.value1) {
                alert('Please provide the value! and try saving')
                return
              }
              currentPattern = item.value1.toString()
            }
            break
          case 'Range':
            if (!item.value1) {
              alert('Please provide the value! and try saving')
              return
            }
            if (!item.value2) {
              alert('Please provide the value! and try saving')
              return
            }
            currentPattern =
              item.value1.toString() + '-' + item.value2.toString()
            break
          case 'Increment':
            if (!item.value1) {
              alert('Please provide the value! and try saving')
              return
            }
            if (!item.value2) {
              alert('Please provide the value! and try saving')
              return
            }
            currentPattern =
              item.value1.toString() + '/' + item.value2.toString()
            break
          case 'Last':
            if (!item.value1) {
              alert('Please provide the value! and try saving')
              return
            }
            currentPattern = item.value1.toString()
            break
          case 'Weekday':
            if (!item.value1) {
              alert('Please provide the value! and try saving')
              return
            }
            currentPattern = item.value1.toString()
            break
          case 'nth Day':
            if (!item.value1) {
              alert('Please provide the value! and try saving')
              return
            }
            currentPattern = item.value1.toString()
            break
        }
        switch (item.selectedType) {
          case 'Second':
            if (
              !localPattern.seconds ||
              localPattern.seconds === '*' ||
              currentPattern === '*'
            ) {
              localPattern.seconds = currentPattern
            } else {
              localPattern.seconds = localPattern.seconds + ',' + currentPattern
            }
            break
          case 'Minute':
            if (
              !localPattern.minutes ||
              localPattern.minutes === '*' ||
              currentPattern === '*'
            ) {
              localPattern.minutes = currentPattern
            } else {
              localPattern.minutes = localPattern.minutes + ',' + currentPattern
            }
            break
          case 'Hour':
            if (
              !localPattern.hours ||
              localPattern.hours === '*' ||
              currentPattern === '*'
            ) {
              localPattern.hours = currentPattern
            } else {
              localPattern.hours = localPattern.hours + ',' + currentPattern
            }
            break
          case 'Day of month':
            if (
              !localPattern.dayOfMonth ||
              localPattern.dayOfMonth === '*' ||
              currentPattern === '*'
            ) {
              localPattern.dayOfMonth = currentPattern
            } else {
              localPattern.dayOfMonth =
                localPattern.dayOfMonth + ',' + currentPattern
            }
            break
          case 'Month':
            if (
              !localPattern.month ||
              localPattern.month === '*' ||
              currentPattern === '*'
            ) {
              localPattern.month = currentPattern
            } else {
              localPattern.month = localPattern.month + ',' + currentPattern
            }
            break
          case 'Day of week':
            if (
              !localPattern.dayOfWeek ||
              localPattern.dayOfWeek === '*' ||
              currentPattern === '*'
            ) {
              localPattern.dayOfWeek = currentPattern
            } else {
              localPattern.dayOfWeek =
                localPattern.dayOfWeek + ',' + currentPattern
            }
            break
          case 'Year':
            if (
              !localPattern.year ||
              localPattern.year === '*' ||
              currentPattern === '*'
            ) {
              localPattern.year = currentPattern
            } else {
              localPattern.year = localPattern.year + ',' + currentPattern
            }
            break
        }
      })
      this.cron.pattern = localPattern
    },
    addInclusion() {
      let count = this.inclusionList.length
      this.inclusionList.unshift(this.initInclusion(++count))
    }
  }
}
</script>

<style scoped>
.schedule_bg {
  background-image: linear-gradient(to right, #ffd900, #ff9400);
}

.btn_padding {
  padding-top: 20px;
  padding-bottom: 30px;
}

.card_height {
  height: 250px;
}

.flex_padding {
  padding: 30px;
}

.fixed-element-light {
  z-index: 998;
  padding-top: 10px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  -webkit-transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2),
    0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12);
  box-shadow: -4px -5px 10px 0px rgba(0, 0, 0, 0.2),
    0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12);
  background-color: #fafafa !important;
  border-color: #fafafa !important;
}

.fixed-element-dark {
  z-index: 998;
  padding-top: 10px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  -webkit-transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2),
    0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12);
  box-shadow: -4px -5px 10px 0px rgba(0, 0, 0, 0.2),
    0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12);
  background-color: #424242 !important;
  border-color: #424242 !important;
}
</style>
